import { render, staticRenderFns } from "./AwardsSingleVideoLink.vue?vue&type=template&id=083c89f0&scoped=true"
import script from "./AwardsSingleVideoLink.vue?vue&type=script&lang=js"
export * from "./AwardsSingleVideoLink.vue?vue&type=script&lang=js"
import style0 from "./AwardsSingleVideoLink.vue?vue&type=style&index=0&id=083c89f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c89f0",
  null
  
)

export default component.exports